module.exports = __webpack_public_path__ + "img/qgsyt2.be7d179e.png";